import { text as moduleText } from './text';
import type { ConfirmRequest } from '@modules/garden-planner/models';

export const text = {
  plantDisplayName(name: string, speciesName?: string): string {
    if (speciesName && speciesName !== name) {
      return moduleText.plantVarietyLabel(speciesName, name);
    }
    return name;
  },

  cellPlantedTooltip(row: number, col: number, plantNames: string[]): string {
    if (plantNames.length === 0) {
      return moduleText.cellLabel(row, col);
    }
    return moduleText.cellWithPlantNames(row, col, plantNames);
  },

  cellAvailabilityClick(isAvailable: boolean): string {
    return isAvailable ? moduleText.cellAvailabilityDisable : moduleText.cellAvailabilityEnable;
  },

  removeRowConfirmCopy(plantsInLastRow: number) {
    return {
      title: moduleText.removeRowTitle,
      message: moduleText.removeRowMessage(plantsInLastRow),
    };
  },

  removeColumnConfirmCopy(plantsInLastCol: number) {
    return {
      title: moduleText.removeColumnTitle,
      message: moduleText.removeColumnMessage(plantsInLastCol),
    };
  },

  buildRemoveRowConfirmRequest(
    plantsInLastRow: number,
    onConfirm: () => Promise<void>
  ): ConfirmRequest {
    const { title, message } = this.removeRowConfirmCopy(plantsInLastRow);
    return { title, message, onConfirm };
  },

  buildRemoveColumnConfirmRequest(
    plantsInLastCol: number,
    onConfirm: () => Promise<void>
  ): ConfirmRequest {
    const { title, message } = this.removeColumnConfirmCopy(plantsInLastCol);
    return { title, message, onConfirm };
  },
};
